import ReactGA from 'react-ga';

export const initGA = () => {
  ReactGA.initialize('UA-187488878-1');
  ReactGA.pageview(window.location.pathname + window.location.search);
};
